/**
 * created by tian ruo jun
 稿件编辑器分流页面
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

export default class EditorShunt extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            configName:"",
            id:"",
        }
    }

    componentWillMount() {
        let configName = this.props.match.params.configName ? this.props.match.params.configName : '';
        this.state.configName = configName;
        let id = this.props.match.params.id ? this.props.match.params.id : '';
        this.state.id = id;
    }

    componentDidMount() {}

    firstWordToUpperCase= (word) => {
        return word.substring(0,1).toUpperCase()+word.substring(1);
    };

    render() {
        let {configName, id}=this.state;
        console.log("configName, id",configName, id)
        let jsName = this.firstWordToUpperCase(configName); // 默认组件名就是文件夹名字首字母大写
        let Editor;
        if(typeof configName == "string"){
            Editor = require(`./${configName}/${jsName}`); // 引入编辑器
        }
        return (
            Editor?
            <Editor.default id={id}/>
            :<div>编辑器文件未找到</div>
        )
    }
}